import { render, staticRenderFns } from "./SurveySingleSurvey.vue?vue&type=template&id=bc160cec&"
import script from "./SurveySingleSurvey.vue?vue&type=script&lang=js&"
export * from "./SurveySingleSurvey.vue?vue&type=script&lang=js&"
import style0 from "./SurveySingleSurvey.vue?vue&type=style&index=0&id=bc160cec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports